import { useLocation, Link } from "react-router-dom";
import { BRAND, NAV } from "@/content/thoratech";

export default function Footer() {
  const location = useLocation();
  const onHome = location.pathname === "/";

  const handleNav = (e, href) => {
    if (!onHome) return; // let Link handle navigation back to /
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  const waPhone = BRAND.contact.phone.replace(/[^\d]/g, "");
  const waLink = `https://wa.me/${waPhone}?text=${encodeURIComponent(
    "Hi Thoratech, I'd like to learn more about your managed customer operations."
  )}`;

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#01080E] text-white pt-20 pb-10 overflow-hidden"
    >
      <div aria-hidden className="absolute inset-0 grid-texture-dark opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-4">
            <img
              src="/brand/TT_Logo_OnDark.svg"
              alt="Thoratech"
              className="h-12 md:h-14 w-auto"
            />
            <p className="mt-4 font-display text-lg text-[#7BDCB5]">{BRAND.tagline}</p>
            <p className="mt-6 max-w-md text-sm text-white/65 leading-relaxed">
              A CX and BPO managed-operations partner. We run customer operations end-to-end with
              SLAs and dashboards from Pune, India.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-white/50">
              Navigate
            </div>
            <ul className="mt-4 space-y-2">
              {NAV.map((n) =>
                onHome ? (
                  <li key={n.href}>
                    <a
                      href={n.href}
                      onClick={(e) => handleNav(e, n.href)}
                      data-testid={`footer-nav-${n.label.replace(/\s+/g, "-").toLowerCase()}`}
                      className="text-sm text-white/80 hover:text-[#2AC0A5] transition-colors"
                    >
                      {n.label}
                    </a>
                  </li>
                ) : (
                  <li key={n.href}>
                    <Link
                      to={`/${n.href}`}
                      data-testid={`footer-nav-${n.label.replace(/\s+/g, "-").toLowerCase()}`}
                      className="text-sm text-white/80 hover:text-[#2AC0A5] transition-colors"
                    >
                      {n.label}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-white/50">
              Company
            </div>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link
                  to="/blog"
                  data-testid="footer-blog"
                  className="text-white/80 hover:text-[#2AC0A5] transition-colors"
                >
                  Field journal (Blog)
                </Link>
              </li>
              <li>
                <Link
                  to="/careers"
                  data-testid="footer-careers"
                  className="text-white/80 hover:text-[#2AC0A5] transition-colors"
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  data-testid="footer-privacy"
                  className="text-white/80 hover:text-[#2AC0A5] transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <a
                  href={BRAND.contact.googleMaps}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-google-maps"
                  className="text-white/80 hover:text-[#2AC0A5] transition-colors"
                >
                  Find us on Google Maps →
                </a>
              </li>
              <li>
                <a
                  href={BRAND.contact.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-linkedin"
                  className="text-white/80 hover:text-[#2AC0A5] transition-colors"
                >
                  LinkedIn (Company) →
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-white/50">
              Reach us
            </div>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a
                  href={`mailto:${BRAND.contact.email}`}
                  data-testid="footer-email"
                  className="text-white/80 hover:text-[#2AC0A5] transition-colors break-all"
                >
                  {BRAND.contact.email}
                </a>
              </li>
              <li className="text-white/80">
                <a
                  href={`tel:${BRAND.contact.phone.replace(/\s+/g, "")}`}
                  data-testid="footer-phone"
                  className="hover:text-[#2AC0A5] transition-colors"
                >
                  {BRAND.contact.phone}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${BRAND.contact.phoneDirect.replace(/\s+/g, "")}`}
                  data-testid="footer-phone-direct"
                  className="text-xs text-white/50 hover:text-[#2AC0A5] transition-colors"
                >
                  Direct: {BRAND.contact.phoneDirect}
                </a>
              </li>
              <li>
                <a
                  href={waLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="text-white/80 hover:text-[#2AC0A5] transition-colors"
                >
                  WhatsApp us →
                </a>
              </li>
              <li className="text-white/80">{BRAND.city}</li>
              <li>
                <a
                  href={`https://${BRAND.website}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-website"
                  className="text-white/80 hover:text-[#2AC0A5] transition-colors"
                >
                  {BRAND.website}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} {BRAND.legal}, {BRAND.city}. All rights reserved.
          </p>
          <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-white/40">
            CX · BPO · Customer Operations
          </p>
        </div>
      </div>
    </footer>
  );
}
